// extracted by mini-css-extract-plugin
export default {"cls1":"ChallengeCodeStep-SectionGrid_cls1__pt-qc","cls2":"ChallengeCodeStep-SectionGrid_cls2__0c16s ChallengeCodeStep-SectionGrid_cls1__pt-qc"};